import { Attr, BelongsTo, Model } from "spraypaint";

import {
  ApplicationRecord,
  objectDirtyChecker,
} from "shared/services/spraypaint";
import type { Nullable } from "shared/types";
import { type SocialMentionType } from "shared/types/mentions";

import type ScheduledReportSpecificationSection from "./ScheduledReportSpecificationSection";
import type Stream from "./Stream";

@Model()
class ScheduledReportSpecificationRule extends ApplicationRecord {
  static jsonapiType = "scheduled_report_specification_rules";

  @Attr() magazineContent: boolean;

  @Attr() onlineContent: boolean;

  @Attr() podcastContent: boolean;

  @Attr() printContent: boolean;

  @Attr() radioContent: boolean;

  @BelongsTo()
  scheduledReportSpecificationSection: ScheduledReportSpecificationSection;

  @Attr() scheduledReportSpecificationSectionId: number;

  @Attr({ dirtyChecker: objectDirtyChecker })
  selectedSocialContent: Nullable<SocialMentionType[]>;

  @Attr() socialContent: boolean;

  @BelongsTo() stream: Stream;

  @Attr() streamId: number;

  @Attr() tvContent: boolean;
}

export default ScheduledReportSpecificationRule;
